@if (true) {
    <div class="container-fluid">
      <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
        {{pageHeader}}
        <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
      <div class="card rounded-4 border-0">
        <div class="card-body">

          <form [formGroup]="addFormCompany" (ngSubmit)="onClickSubmit(addFormCompany.value)">

            <div class="row">

              <!-- Company Name -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>
                    Company Name <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="companyName"
                    placeholder="Enter Company Name"/>
                    @if (f.companyName.touched && f.companyName.invalid) {
                      @if (f.companyName.errors?.['required']) {
                        <div class="text-danger">Company Name is required</div>
                      }
                    }
                </div>
              </div>

              <!-- Address -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>Address <span class="text-danger">*</span> </label>
                  <textarea
                    class="form-control"
                    formControlName="address"
                    rows="2"
                    placeholder="Address">
                  </textarea>
                  @if (f.address.touched && f.address.invalid) {
                    @if (f.address.errors?.['required']) {
                      <div class="text-danger">Address is required</div>
                    }
                  }
                </div>
              </div>

              <!-- State -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>
                    <a [href]="RouteGMState" target="_blank">State</a> <span class="text-danger">*</span>
                  </label>
                  <ng-select
                    [items]="State"
                    bindLabel="MainDescr"
                    bindValue="hdID"
                    formControlName="State"
                    (change)="onStateSelect($event)"
                    [clearable]="false"
                    placeholder="Select State">
                    <ng-option [value]="'0'">Not Selected</ng-option>
                  </ng-select>
                  @if (f.State.touched && f.State.invalid) {
                    @if (f.State.errors?.['required']) {
                      <div class="text-danger">State is required</div>
                    }
                  }
                </div>
              </div>

              <!-- Mobile -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>Mobile <span class="text-danger">*</span> </label>
                  <input
                    class="form-control"
                    formControlName="MobileNumber"
                    placeholder="Enter Mobile No"
                    type="number" />
                    @if (f.MobileNumber.touched && f.MobileNumber.invalid) {
                      @if (f.MobileNumber.errors?.['required']) {
                        <div class="text-danger">Mobile is required</div>
                      }
                    }
                </div>
              </div>

              <!-- City -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>
                    <a [href]="RouteGMCity" target="_blank">City <span class="text-danger">*</span> </a>
                  </label>
                  <ng-select
                    [items]="City"
                    bindLabel="MainDescr"
                    bindValue="hdID"
                    formControlName="City"
                    [clearable]="false"
                    placeholder="Select City">
                    <ng-option [value]="'0'">Not Selected</ng-option>
                  </ng-select>
                  @if (f.City.touched && f.City.invalid) {
                    @if (f.City.errors?.['required']) {
                      <div class="text-danger">City is required</div>
                    }
                  }
                </div>
              </div>

              <!-- Work Phone -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>Work Phone</label>
                  <input
                    class="form-control"
                    formControlName="workphone"
                    placeholder="Work Phone"
                    type="number" />
                </div>
              </div>

              <!-- Work Fax -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>Work Fax</label>
                  <input
                    class="form-control"
                    formControlName="faxno"
                    placeholder="Enter Fax No"
                    type="text" />
                </div>
              </div>

              <!-- Work Phone 1 -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>Work Phone 1</label>
                  <input
                    class="form-control"
                    formControlName="workphone2"
                    placeholder="Enter work phone 1"
                    type="text" />
                </div>
              </div>

              <!-- Email -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>Email <span class="text-danger">*</span> </label>
                  <input
                    class="form-control"
                    formControlName="email1"
                    placeholder="Enter Email"
                    type="email" />
                    @if (f.email1.touched && f.email1.invalid) {
                      @if (f.email1.errors?.['required']) {
                        <div class="text-danger">Email is required</div>
                      }
                    }
                </div>
              </div>

              <!-- Email 1 -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>Email 1</label>
                  <input
                    class="form-control"
                    formControlName="email2"
                    placeholder="Enter Email1 (if available)"
                    type="email" />
                </div>
              </div>

            </div>

            <!-- Submit -->
             @if (RightsID.includes('202040021') || RightsID.includes('202040001')) {
              <div class="d-flex align-items-center justify-content-center mt-4">
                <button
                  class="btn btn-primary submit-btn small"
                  [disabled]="disableButton"
                  type="submit">
                  {{ buttonname }}
                </button>
              </div>
             }

          </form>

        </div>
      </div>


    </div>
} @else {
  <!-- <my-content placeholder="navigation">
    <div class="col-sm-12 divbordergry"></div>
    <div class="col-sm-12">
      <div class="titlebar d-flex align-items-center justify-content-between">
        <div></div>
        <div class="titlebar-text">
          <i class="fa fa-briefcase text-primary"></i>
          <span class="ml-2 page-title">{{pageHeader}}</span>
        </div>
        <button class="btn btn-primary back-btn" title="Go Back" (click)="goBack()">
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
      <form
        #createCompnay="ngForm"
        [formGroup]="addFormCompany"
        (ngSubmit)="onClickSubmit(createCompnay.value); disabled = true"
      >
        <fieldset>
          <table width="100%">
            <tr>
              <td width="15%">Company Name*</td>
              <td width="35%">
                <div class="col-sm-10">
                  <input
                    type="text"
                    formControlName="companyName"
                    class="form-control"
                    [ngClass]="{
                      'is-invalid': submitted && f.companyName.errors
                    }"
                    placeholder="Enter Company Name"
                    required="required"
                  />
                </div>
                <div
                  *ngIf="submitted && f.companyName.errors"
                  class="invalid-feedback"
                >
                  <div *ngIf="f.companyName.errors.required">required</div>
                </div>
              </td>
              <td width="15%">Address</td>
              <td width="35%">
                <div class="col-sm-10">
                  <textarea
                    class="form-control"
                    formControlName="address"
                    rows="2"
                    placeholder="Address"
                  ></textarea>
                </div>
              </td>
            </tr>
            <tr>
              <td><a href="{{ RouteGMState }}" target="_blank">State</a></td>
              <td>
                <div class="col-sm-10">
                  <ng-select
                    [items]="State"
                    bindLabel="MainDescr"
                    bindValue="hdID"
                    formControlName="State"
                    (change)="onStateSelect($event)"
                    [clearable]="false"
                    placeholder="Not Selected">
                    <ng-option [value]="'0'">Not Selected</ng-option>
                  </ng-select>
                </div>
              </td>
              <td>Mobile</td>
              <td>
                <div class="col-sm-10">
                  <input
                    class="form-control"
                    placeholder="Enter Mobile No"
                    formControlName="MobileNumber"
                    type="text"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td><a href="{{ RouteGMCity }}" target="_blank">City</a></td>
              <td>
                <div class="col-sm-10">
                  <ng-select
                    [items]="City"
                    bindLabel="MainDescr"
                    bindValue="hdID"
                    formControlName="City"
                    [clearable]="false"
                    placeholder="Not Selected">
                    <ng-option [value]="'0'">Not Selected</ng-option>
                  </ng-select>
                </div>
              </td>
              <td>Work Phone</td>
              <td>
                <div class="col-sm-10">
                  <input
                    class="form-control"
                    placeholder="Work Phone"
                    formControlName="workphone"
                    type="text"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>Work Fax</td>
              <td>
                <div class="col-sm-10">
                  <input
                    class="form-control"
                    placeholder="Enter Fax No"
                    formControlName="faxno"
                    type="text"
                  />
                </div>
              </td>
              <td>Work Phone 1</td>
              <td>
                <div class="col-sm-10">
                  <input
                    class="form-control"
                    placeholder="Enter work phone 1"
                    formControlName="workphone2"
                    type="text"
                  />
                </div>
              </td>
            </tr>
  
            <tr>
              <td>Email</td>
              <td>
                <div class="col-sm-10">
                  <input
                    class="form-control"
                    placeholder="Enter Email"
                    formControlName="email1"
                    type="email"
                  />
                </div>
              </td>
              <td>Email 1</td>
              <td>
                <div class="col-sm-10">
                  <input
                    class="form-control"
                    placeholder="Enter Email1 (if available)"
                    formControlName="email2"
                    type="email"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="4" >
                <br />
                <div
                  *ngIf="
                    this.RightsID.includes('202040001') ||
                      this.RightsID.includes('202040021');
                    then AddCompanyLink;
                    else AddCompany
                  "
                ></div>
                <ng-template #AddCompanyLink>
                  <div class="col-sm-12 d-flex">
                    <input
                      class="btn btn-primary mx-auto"
                      [disabled]="disableButton"
                      type="submit"
                      name="abc"
                      value="{{ buttonname }}"
                      ngmodel
                    />
                  </div>
                </ng-template>
                <ng-template #AddCompany>
                  <div class="col-sm-4">&nbsp;</div>
                </ng-template>
              </td>
            </tr>
          </table>
        </fieldset>
      </form>
      <div>
        &nbsp;<br />&nbsp;&nbsp;<br />&nbsp;<br />&nbsp;&nbsp;&nbsp;<br />&nbsp;&nbsp;<br />&nbsp;<br />&nbsp;&nbsp;
      </div>
    </div>
  </my-content>
  <my-content placeholder="main"> </my-content> -->
  
}
